module.exports = __webpack_public_path__ + "static/media/experiment-quilt.fd1f97d2.mov";